<template>

</template>

<script>
export default {
    name: "thing_show"
}
</script>